import verifyIcon from '../../assets/icons/verify.png'
import fallbackImage from '../../assets/images/astrologer.png'

export default function SupplierCard({ provider }) {
  if (!provider) return null

  const imageSrc = provider.image || fallbackImage
  const experienceLabel = provider.experience
    ? `${provider.experience} years experience`
    : ''

  return (
    <article className="supplier-card second-bg h-100 d-flex flex-column">
      <div className="supplier-card__media position-relative">
        <img
          src={imageSrc}
          alt={provider.name}
          className="supplier-card__image"
          onError={(event) => {
            event.currentTarget.onerror = null
            event.currentTarget.src = fallbackImage
          }}
        />
        {provider.isVerified && (
          <img
            src={verifyIcon}
            alt="Verified"
            className="supplier-card__verify"
          />
        )}
      </div>

      <div className="supplier-card__body">
        <h4 className="supplier-card__name text-lora mb-1">{provider.name}</h4>
        {provider.role && (
          <p className="supplier-card__meta mb-0">{provider.role}</p>
        )}
        {experienceLabel && (
          <p className="supplier-card__meta mb-0">{experienceLabel}</p>
        )}
        {provider.location && (
          <p className="supplier-card__meta mb-0">{provider.location}</p>
        )}
        {provider.bio && (
          <p className="supplier-card__bio mb-0">{provider.bio}</p>
        )}
      </div>
    </article>
  )
}
